export default __webpack_public_path__ + "static/media/vip11-bg.19b4fff8.jpg";